import React, { useEffect, useState, useRef, Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import ChatView from './ChatView'
import actions from '../../store/actions'
import userDummyIcon from '../NewHeader/images/user.svg'
import assistance from './assets/assistance_new.jpg'
import speechActiveSvg from './assets/speechActive.svg'
import speechInactiveSvg from './assets/speachInactive.svg'
import micActiveSvg from './assets/micActive.svg'
import micInactiveSvg from './assets/micInactive.svg'
import photoActiveSvg from './assets/photoActive.svg'
import photoInactiveSvg from './assets/photoInactive.svg'
import avatarImg from './assets/avatar.png'
import botAvatar from '../NewHeader/images/sharebot-robot.png'
import './styles.scss'
import CoachModal from './CoachModal'
import { Button, Input, Typography, Select, Card, Radio } from 'antd'
const { Option } = Select
const { Title, Text, Paragraph } = Typography
const assistanceResources = {
  type: 'TYPE',
  speak: 'SPEACK',
  Image: 'IMAGE'
}
const imageTypes = [
  'Baby',
  'Room',
  'Home',
  'Flower',
  'Frame',
  'Party',
  'Mommy',
  'Playground',
  'Business Man',
  'Woman',
  'Family'
]

function ShareAssistance({ onHoverStart, onHoverEnd }) {
  const ref = useRef(null)
  const chatContainerRef = useRef(null)

  useEffect(() => {
    const el = ref.current
    const chatContainer = chatContainerRef.current

    if (!el) return

    const stopScroll = e => {
      // Always prevent parent container from scrolling
      if (
        !chatContainerRef.current ||
        !chatContainerRef.current.contains(e.target)
      ) {
        e.preventDefault()
        e.stopPropagation()
        return
      }

      // For the chat container specifically, check if we're at boundaries
      if (chatContainerRef.current.contains(e.target)) {
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = chatContainerRef.current
        const isAtTop = scrollTop <= 0
        const isAtBottom =
          Math.abs(scrollHeight - scrollTop - clientHeight) <= 1

        // If at top and trying to scroll up, or at bottom and trying to scroll down
        if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
          e.preventDefault()
          e.stopPropagation()
        }
      }
    }

    el.addEventListener('wheel', stopScroll, { passive: false })
    el.addEventListener('touchmove', stopScroll, { passive: false })

    return () => {
      el.removeEventListener('wheel', stopScroll)
      el.removeEventListener('touchmove', stopScroll)
    }
  }, [])

  const [showAssistance, setShowAssistance] = useState(false)
  const [promptText, setPromptText] = useState('')
  const [coachModal, openCoachModal] = useState(false)
  const [activeBotResource, setActiveBotResource] = useState(
    assistanceResources.speak
  )
  const [botHistory, setBotHistory] = useState([])
  const [coacherHistory, setCoacherHistory] = useState([])
  const [message, setMessage] = useState('')

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  const sharebot = useSelector(state => state.sharebot)
  const [isCoacher, setIsCoacher] = useState(false)

  // Get user avatar
  const userAvatar = getUserAvatar(user)

  useEffect(() => {
    setShowAssistance(sharebot.showAssistance)
  }, [sharebot.showAssistance])

  useEffect(() => {
    return () => {
      setBotHistory([])
      setCoacherHistory([])
    }
  }, [])

  useEffect(() => {
    if (!showAssistance) {
      setBotHistory([])
      setCoacherHistory([])
      dispatch(actions.sharebot.disableAssistance())
    }
  }, [showAssistance, dispatch])

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }, [botHistory, coacherHistory])

  // Add an effect to handle chat container scroll behavior
  useEffect(() => {
    if (!chatContainerRef.current) return

    const chatContainer = chatContainerRef.current

    const handleChatScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = chatContainer
      const isAtTop = scrollTop <= 0
      const isAtBottom = Math.abs(scrollHeight - scrollTop - clientHeight) <= 1

      // If at top and trying to scroll up, or at bottom and trying to scroll down
      if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
        e.preventDefault()
        e.stopPropagation()
      }
    }

    chatContainer.addEventListener('wheel', handleChatScroll, {
      passive: false
    })

    return () => {
      chatContainer.removeEventListener('wheel', handleChatScroll)
    }
  }, [])

  const toggleBot = () => setShowAssistance(val => !val)

  const handleSendMessage = e => {
    if (e.key === 'Enter' && message.trim()) {
      const newUserMessage = {
        type: 'user',
        text: message,
        timestamp: new Date(),
        avatar: userAvatar
      }
      if (isCoacher) {
        setCoacherHistory(prev => [...prev, newUserMessage])
      } else {
        setBotHistory(prev => [...prev, newUserMessage])
      }
      setMessage('')
    }
  }

  const handleMessageChange = e => {
    setMessage(e.target.value)
  }

  // Helper function to get user avatar
  function getUserAvatar(user) {
    if (user && user.info && user.info.avatar) {
      if (user.info.avatar.resizes && user.info.avatar.resizes.thumbnail) {
        return user.info.avatar.resizes.thumbnail
      } else if (user.info.avatar.link) {
        return user.info.avatar.link
      }
    }
    return userDummyIcon
  }

  return (
    <div
      className="assistance-wrapper"
      onMouseEnter={onHoverStart}
      ref={ref}
      onMouseLeave={onHoverEnd}
    >
      {showAssistance && (
        <div className="assistance-container">
          <div className="assistance-header">
            <h2>{t('v5:talk_with_course_assistants')}</h2>
            <button className="assistance-close-button" onClick={toggleBot}>
              ×
            </button>
          </div>

          <ChatHeader
            t={t}
            activeBotResource={activeBotResource}
            setActiveBotResource={setActiveBotResource}
          />

          {activeBotResource === assistanceResources.type && (
            <Fragment>
              <div style={{
                padding: '12px 16px',
                display: 'flex',
                justifyContent: 'center',
                background: '#ffffff',
                borderBottom: '1px solid #f0f0f0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                position: 'relative',
                zIndex: 1
              }}>
                <Radio.Group
                  value={isCoacher}
                  onChange={e => setIsCoacher(e.target.value)}
                  optionType="button"
                  buttonStyle="solid"
                  size="middle"
                  style={{
                    width: '100%',
                    display: 'flex',
                    borderRadius: '6px',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
                  }}
                >
                  <Radio.Button
                    value={false}
                    style={{
                      flex: 1,
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px',
                      borderRadius: '6px 0 0 6px'
                    }}
                  >
                    Sharelook Bot
                  </Radio.Button>
                  <Radio.Button
                    value={true}
                    style={{
                      flex: 1,
                      textAlign: 'center',
                      fontWeight: '500',
                      fontSize: '13px',
                      borderRadius: '0 6px 6px 0'
                    }}
                  >
                    Sharelook Coacher
                  </Radio.Button>
                </Radio.Group>
              </div>

              <div className="assistance-messages" ref={chatContainerRef}>
                <ChatView
                  user={user}
                  botHistory={botHistory}
                  setBotHistory={setBotHistory}
                  coacherHistory={coacherHistory}
                  setCoacherHistory={setCoacherHistory}
                  activeBotResource={activeBotResource}
                  botAvatar={botAvatar}
                  isCoacher={isCoacher}
                />
              </div>

              <div className="assistance-input">
                <input
                  type="text"
                  value={message}
                  onChange={handleMessageChange}
                  onKeyPress={handleSendMessage}
                  placeholder={t('v3:sharebot_help_message')}
                />
              </div>
            </Fragment>
          )}
          {activeBotResource === assistanceResources.speak && (
            <div className="assistance-speak" ref={chatContainerRef}>
              <CoachModal
                visible={coachModal}
                onClose={() => openCoachModal(false)}
              />
              <div className="coacher-container">
                <Title level={3} className="coacher-title">
                  {t('v5:select_your_coacher')}
                </Title>
                <Select
                  defaultValue="Mahesh Joshi - Life Coach | Monk"
                  className="coacher-select"
                  suffixIcon={<span className="custom-arrow">▼</span>}
                >
                  <Option value="Mahesh Joshi - Life Coach | Monk">
                    DGF Logistic  - Coacher
                  </Option>
                </Select>

                <Card bordered={false} className="coacher-card">
                  <div className="coacher-image-wrapper">
                    <img
                      src={assistance}
                      alt="coach_profile"
                      className="coacher-image"
                    />
                  </div>
                  {/* <Title level={3} className="coacher-name">
                    {t('v5:simon_witts')}
                  </Title> */}
                  <Text className="coacher-role">
                    DGF Logistic  - Coacher
                  </Text>
                  <Paragraph className="coacher-status">
                    {t('v5:coacher_mode_active')}
                  </Paragraph>
                  {/* <Paragraph className="coacher-description">
                    {t('v5:your_personal_coaching_experience')} <br />
                    {t('v5:powered_by')}{' '}
                    <a
                      href="https://www.caa.co.uk"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('v5:uk_civil_viation_authority_data')}
                    </a>
                  </Paragraph> */}

                  <Button
                    type="primary"
                    size="large"
                    className="coacher-button"
                    onClick={() => openCoachModal(true)}
                  >
                    {t('v5:start_coaching_session')}
                  </Button>
                </Card>
              </div>
            </div>
          )}
          {activeBotResource === assistanceResources.image && (
            <div className="assistance-image" ref={chatContainerRef}>
              <div className="assistance-image-avatar">
                <img src={avatarImg} alt="avatar_img" />
              </div>
              <div className="assistance-image-text">
                <p>{t('v5:what_image_do_you_need')}</p>
              </div>
              <div className="assistance-image-type-wrapper">
                {imageTypes.map(type => (
                  <div
                    className="assistance-image-type"
                    key={type}
                    onClick={() => setPromptText(type)}
                  >
                    <p>{type}</p>
                  </div>
                ))}
              </div>

              <div className="prompt-input">
                <Input
                  value={promptText}
                  onChange={e => setPromptText(e.target.value)}
                  placeholder={t('v5:write_something')}
                  allowClear
                />
              </div>
              <div className="btn-generate">
                <Button
                  type="primary"
                  size="large"
                  style={{
                    backgroundColor: '#6b7bff',
                    borderRadius: 20,
                    paddingLeft: 20,
                    paddingRight: 20
                  }}
                >
                  {t('v3:generate')}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

const ChatHeader = ({ t, activeBotResource, setActiveBotResource }) => {
  return (
    <div className="assistance-tabs">
      <div
        className={`assistance-tab ${activeBotResource === assistanceResources.type ? 'active' : ''
          }`}
        role="button"
        onClick={() => setActiveBotResource(assistanceResources.type)}
      >
        <img
          src={
            activeBotResource === assistanceResources.type
              ? speechActiveSvg
              : speechInactiveSvg
          }
          alt={'alt-type'}
        />
        {t('general:type')}
      </div>
      <div
        className={`assistance-tab ${activeBotResource === assistanceResources.speak ? 'active' : ''
          }`}
        role="button"
        onClick={() => setActiveBotResource(assistanceResources.speak)}
      >
        <img
          src={
            activeBotResource === assistanceResources.speak
              ? micActiveSvg
              : micInactiveSvg
          }
          alt={'alt-speak'}
        />
        {t('v5:speak')}
      </div>
      {/* <div
                className={`assistance-tab ${activeBotResource === assistanceResources.image ? 'active' : ''}`}
                role="button"
                onClick={() => setActiveBotResource(assistanceResources.image)}
            >
                <img src={activeBotResource === assistanceResources.image ? photoActiveSvg : photoInactiveSvg} alt={"alt-image"} /> Image
            </div> */}
    </div>
  )
}

export default ShareAssistance
